import IpsDropdown from './IpsDropdown.vue';
import '../../../styles/custom.scss';

export default IpsDropdown;
